import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DeleteForm from "./DeleteForm";
import WeaknessesDetails from "../pages/weaknesses/WeaknessesDetails";
import AssetsDetails from "../pages/asset/AssetDetails";
import { translate } from "../utils/utils";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import Grid from "@mui/material/Grid";
import NoData from "../../src/assets/noAssets.png";
export default function SimpleAccordion({
  data,
  disabled,
  head,
  type,
  handleOpen,
  handleData,
  handleUpdate,
  id_owner,
  company,
  riskAsset,
  riskWeakness,
  risk,
  handleOpenDetails,
  enterprise,
  accountType,
  accountId,
}) {
  const history = useHistory();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openWeakness, setOpenWeakness] = useState(false);
  const [openAsset, setOpenAsset] = useState(false);
  const [rowDetails, setRowDetails] = useState({});
  const [id, setId] = useState("");
  const [weaknessDetails, setWeaknessDetails] = useState({});

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseWeakness = () => {
    setOpenWeakness(false);
  };

  const handleCloseAsset = () => {
    setOpenAsset(false);
  };

  const handleSelectedWeakness = (row) => {
    setOpenWeakness(true);
    setId(row.id);
  };

  const handleSelectedAsset = (row) => {
    if (type === "asset") {
      setOpenAsset(true);
      setId(row.id);
    } else {
      setOpenWeakness(true);
      setWeaknessDetails(row);
    }
  };

  const handleSelectedRisk = (row) => {
    history.push(`/risk/${row.id}`);
    setId(row.id);
    handleData(row);
  };

  return data?.map((el) => (
    <>
      <div>
        <Accordion key={el?.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{
              backgroundColor: "#F3FBF9",
              borderBottom: "none",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1,
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              color: "#494949",

              "& .MuiTypography-root": {
                margin: 0,
                fontSize: "12px",
                fontWeight: 900,
                fontFamily:
                  "Poppins,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji",
                lineHeight: 1.5,
                letterSpacing: "0.00938em",
                "& .MuiPaper-root": { boxShadow: "none" },
              },
            }}
          >
            <div>
              <Typography>
                {el?.[translate("title")] || t("not_specified")}
              </Typography>
              <br />
              <Typography>Source : {el?.source}</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottom: "none",
              fontSize: "12px",
              fontWeight: 800,
              lineHeight: 1,
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              color: "#121828",

              "& .MuiTypography-root": {
                margin: 0,
                fontSize: "12px",
                fontWeight: 800,
                fontFamily:
                  "Poppins,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji",
                lineHeight: 1.5,
                letterSpacing: "0.00938em",
                "& .MuiPaper-root": { boxShadow: "none" },
              },
            }}
          >
            <Typography>
              <>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "5px 20px",
                  }}
                >
                  {" "}
                  <div>
                    <span
                      style={{ color: "rgb(71 138 119)", marginBottom: "" }}
                    >
                      {riskAsset ? head[1]?.value : head[2]?.value} :
                    </span>{" "}
                    {!riskAsset && (
                      <>
                        <br />
                        <br />
                      </>
                    )}
                    <span>
                      {riskAsset
                        ? el?.value
                        : el?.[translate("description")] || t("not_specified")}
                    </span>
                  </div>
                </span>
                <hr style={{ borderColor: "#B1B4BC5C" }} />

                <div style={{ margin: "25px 5px" }}>
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{
                      height: "40px",
                      width: "100%",
                      color: "black",
                      borderColor: "black",
                    }}
                    onClick={() => {
                      handleSelectedAsset(el);
                    }}
                  >
                    <ControlPointOutlinedIcon /> &nbsp; {t("show_details")}
                  </Button>
                  <br />
                  {(parseInt(risk?.organization_id) === parseInt(id_owner) ||
                    risk?.source === enterprise) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "5px",
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        sx={{
                          height: "40px",
                          width: "100%",
                          m: "5px 5px",
                        }}
                        onClick={(e) => {
                          setOpen(true);
                          e.stopPropagation();
                          setRowDetails(el);
                          setId(el.id);
                        }}
                      >
                        <DeleteForeverOutlinedIcon />
                        {t("delete")}
                      </Button>
                    </div>
                  )}
                </div>
              </>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <br />
      </div>
      <DeleteForm
        open={open}
        handleClose={handleClose}
        id={id}
        rowDetails={rowDetails}
        type={type}
        riskAsset={riskAsset}
        riskWeakness={riskWeakness}
        risk={risk}
        accountType={accountType}
        accountId={accountId}
      />
      <WeaknessesDetails
        open={openWeakness}
        handleClose={handleCloseWeakness}
        disabled={disabled}
        handleOpen={handleOpen}
        handleUpdate={handleUpdate}
        id={id}
        data={data}
        rowDetails={weaknessDetails}
        id_owner={id_owner}
        company={company}
        show={!riskWeakness}
      />
      <AssetsDetails
        open={openAsset}
        handleClose={handleCloseAsset}
        disabled={disabled}
        handleOpen={handleOpen}
        handleUpdate={handleUpdate}
        id={id}
        data={data}
        id_owner={id_owner}
        company={company}
        show={!riskAsset}
      />
      {data.length === 0 && (
        <Grid container sx={{ textAlign: "center", mt: "100px" }}>
          <Grid item xs={12}>
            <Typography variant="title">No Data Found</Typography>
          </Grid>
          <Grid item xs={12}>
            <img src={NoData} alt="No Data" />
          </Grid>
        </Grid>
      )}
    </>
  ));
}
